import { render, staticRenderFns } from "./AccommodationSlideOver.vue?vue&type=template&id=61d4d09b"
import script from "./AccommodationSlideOver.vue?vue&type=script&setup=true&lang=ts"
export * from "./AccommodationSlideOver.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports